import React from 'react';
import Time from './Time';

export default ({ event, state }) => {
  const { eventTimes } = state.state;

  const eventTime = eventTimes[event.happened_at];
  return (
    <li className="timeline__item">
      <div className="event event--flow">
        End Period {event.period}<br />
        <Time time={eventTime}/>
      </div>
    </li>
  );
}
